import Decimal from 'decimal.js'
import type { LedgerItem, MoneyDto, SaleItem } from '../api/admin.api'
import { isGatewayLedgerEntry } from './admin-sale-detail-money'

export function providerChargeResult(sale: SaleItem, entries: LedgerItem[]) {
  const gross = sale.providerSettlementAmount
  const fee = sale.providerFeeAmount
  if (!gross || !fee || gross.currency !== fee.currency) return null
  const original = entries.filter(
    (entry) => entry.source === 'SALE' || entry.source === 'CURRENCY_CONVERSION',
  )
  if (
    !original.some((entry) => entry.type === 'VENDEPAY') ||
    !original.some((entry) => entry.type === 'USER' || entry.type === 'RESERVE') ||
    original.some(
      (entry) =>
        entry.amount.currency !== gross.currency ||
        isGatewayLedgerEntry(entry) ||
        (!['VENDEPAY', 'USER', 'RESERVE'].includes(entry.type) &&
          !(entry.type === 'COMMISSION' && entry.source === 'SALE' && entry.role === 'referral')),
    )
  )
    return null

  try {
    const grossValue = new Decimal(gross.amount)
    const feeValue = new Decimal(fee.amount)
    const amounts = original.map((entry) => new Decimal(entry.amount.amount))
    if (
      [grossValue, feeValue].some((value) => !value.isFinite() || value.isNegative()) ||
      amounts.some(
        (value, index) =>
          !value.isFinite() ||
          (value.isNegative() &&
            !(
              original[index]?.type === 'VENDEPAY' &&
              original[index]?.source === 'SALE' &&
              original[index]?.role === 'referral'
            )),
      )
    ) {
      return null
    }
    const total = Decimal.sum(...amounts)
    if (!total.eq(grossValue)) return null
    // Referral credits reallocate the platform fee and must have matching funding.
    const referrals = original.filter((entry) => entry.role === 'referral')
    if (
      referrals.length > 0 &&
      (referrals.some(
        (entry) =>
          entry.source !== 'SALE' || !['VENDEPAY', 'COMMISSION', 'RESERVE'].includes(entry.type),
      ) ||
        !Decimal.sum(...referrals.map((entry) => entry.amount.amount)).isZero())
    )
      return null
    const platform = Decimal.sum(
      0,
      ...original.filter((entry) => entry.type === 'VENDEPAY').map((entry) => entry.amount.amount),
    )
    const money = (amount: Decimal): MoneyDto => ({
      amount: amount.toFixed(3),
      currency: gross.currency,
    })
    return {
      gross,
      fee,
      participants: money(total.minus(platform)),
      platformGross: money(platform),
      platformNet: money(platform.minus(feeValue)),
    }
  } catch {
    return null
  }
}
